/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-confusing-browser-globals */

'use es6';

import { useSelector } from 'react-redux';
import { fromJS, Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import { getReportDashboardInfo as getParentDashboards, getUpdatedByUser, getUpdatedAt, getReportOwnerUser, getBusinessUnitId } from 'reporting-action-components/data/schemas/reportSchema';
import { hasSufficientReportEditPermission } from 'reporting-action-components/lib/report-logic';
import CheckboxCell from './cells/CheckboxCell';
import BusinessUnitCell from './cells/BusinessUnitCell';
import NameCell from './cells/ReportNameCell';
import UserCell from './cells/UserCell';
import DateCell, { DATE_CELL_USE } from './cells/DateCell';
import FavoriteCell from './cells/FavoriteCell';
import DashboardCountCell from './cells/DashboardCountCell';
import AssignedCell from './cells/AssignedCell';
import { selectIsUnusedFilterActive } from '../../selectors/reportsSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReportsTableRow = ({
  report,
  isSelected,
  onAddToDashboard,
  onClone,
  onSelectedChange,
  onUpdate
}) => {
  const parentDashboards = getParentDashboards(report);
  const unusedFilterActive = useSelector(selectIsUnusedFilterActive);
  const handleSelectedChange = ({
    target: {
      checked
    }
  }) => onSelectedChange(report, checked);
  const disableBulkAction = !hasSufficientReportEditPermission(report);
  const lastViewedTimestamp = report.get('lastViewedAt');
  const lastViewedUser = report.get('lastViewUser');
  const lastUpdatedTimestamp = getUpdatedAt(report);
  const lastUpdatedUser = getUpdatedByUser(report);
  const dateCellUse = unusedFilterActive ? DATE_CELL_USE.RELATIVE : DATE_CELL_USE.DEFAULT;
  return /*#__PURE__*/_jsxs("tr", {
    "data-test-id": "reports-table-row",
    children: [/*#__PURE__*/_jsx(CheckboxCell, {
      isDisabled: disableBulkAction,
      isSelected: isSelected,
      handleSelectedChange: handleSelectedChange
    }), /*#__PURE__*/_jsx(FavoriteCell, {
      report: report
    }), /*#__PURE__*/_jsx(NameCell, {
      onAddToDashboard: onAddToDashboard,
      onClone: onClone,
      onUpdate: onUpdate,
      report: report,
      history: history
    }), /*#__PURE__*/_jsx(DashboardCountCell, {
      parentDashboards: fromJS(parentDashboards)
    }), /*#__PURE__*/_jsx(UserCell, {
      user: getReportOwnerUser(report)
    }), /*#__PURE__*/_jsx(BusinessUnitCell, {
      buId: getBusinessUnitId(report)
    }), /*#__PURE__*/_jsx(AssignedCell, {
      report: report
    }), /*#__PURE__*/_jsx(DateCell, {
      timestamp: lastViewedTimestamp,
      user: lastViewedUser,
      tooltipText: 'reports.subHeader.lastViewed.tooltip',
      use: dateCellUse
    }), /*#__PURE__*/_jsx(DateCell, {
      timestamp: lastUpdatedTimestamp,
      user: lastUpdatedUser,
      use: dateCellUse
    })]
  });
};
ReportsTableRow.propTypes = {
  report: PropTypes.instanceOf(ImmutableMap).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onAddToDashboard: PropTypes.func.isRequired,
  onClone: PropTypes.func.isRequired,
  onSelectedChange: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired
};
export default ReportsTableRow;